import { render, staticRenderFns } from "./itemModifiersCombo.vue?vue&type=template&id=02c56706&scoped=true&"
import script from "./itemModifiersCombo.vue?vue&type=script&lang=js&"
export * from "./itemModifiersCombo.vue?vue&type=script&lang=js&"
import style0 from "./itemModifiersCombo.vue?vue&type=style&index=0&id=02c56706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c56706",
  null
  
)

export default component.exports